var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.useDvFlag("beepiz-action-point-can:create")
    ? _c("form", { staticClass: "form p-0" }, [
        _c("h2", { staticClass: "text-xl font-semibold mt-0 mb-4" }, [
          _vm._v(_vm._s(_vm.formTitle)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-row row special-photo-input" },
          [
            _c("PhotoInput", {
              ref: "APPhoto",
              attrs: {
                id: "APPhoto",
                accept: "image/jpeg,image/png,image/gif",
                margin: "0",
                width: "500",
                height: "200",
                size: "2",
                buttonClass: "action-button",
                removeButtonClass: "action-button",
                crop: false,
                removable: true,
                customStrings: {
                  upload: _vm.$t("global.form.pictureinput.upload"),
                  drag: _vm.$t("global.form.pictureinput.drag"),
                  tap: _vm.$t("global.form.pictureinput.tap"),
                  change: _vm.$t("global.form.pictureinput.change"),
                  remove: _vm.$t("global.form.pictureinput.remove"),
                  select: _vm.$t("global.form.pictureinput.select"),
                  selected: _vm.$t("global.form.pictureinput.selected"),
                  fileSize: _vm.$t("global.form.pictureinput.fileSize"),
                  fileType: _vm.$t("global.form.pictureinput.fileType"),
                  aspect: _vm.$t("global.form.pictureinput.aspect"),
                },
              },
              on: { change: _vm.onPhotoSelect, error: _vm.handlePhotoError },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-row row" }, [
          _c("label", { staticClass: "col-4" }, [
            _vm._v(_vm._s(_vm.$t("ap.library.form.label"))),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.ap.name,
                expression: "ap.name",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form-input col",
            attrs: {
              type: "text",
              name: "label",
              "data-vv-rules": "required",
              "data-vv-as": _vm.$t("ap.library.form.label"),
              "data-vv-validate-on": "none",
            },
            domProps: { value: _vm.ap.name },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.ap, "name", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showErrors["label"] && _vm.errors.has("label"),
                  expression: "showErrors['label'] && errors.has('label')",
                },
              ],
              staticClass: "form-input-error",
              on: {
                click: function ($event) {
                  return _vm.hideError("label")
                },
              },
            },
            [_vm._v(_vm._s(_vm.errors.first("label")))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row row" }, [
          _c("label", { staticClass: "col-4" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("ap.library.form.type")) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ap.type,
                  expression: "ap.type",
                },
                { name: "validate", rawName: "v-validate" },
              ],
              staticClass: "form-input col",
              staticStyle: {
                "font-family":
                  "'FontAwesome','Material-Design-Iconic-Font',Arial",
              },
              attrs: {
                name: "type",
                "data-vv-rules": "required",
                "data-vv-as": _vm.$t("ap.library.form.type"),
                "data-vv-validate-on": "none",
              },
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.ap,
                      "type",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.handleTypeChange,
                ],
              },
            },
            [
              _c("option", { attrs: { value: "" } }),
              _vm._v(" "),
              _vm._l([1, 2, 3, 4, 5], function (n) {
                return _c("option", {
                  staticStyle: {
                    "font-family":
                      "'FontAwesome','Material-Design-Iconic-Font',Arial",
                  },
                  domProps: {
                    value: n,
                    innerHTML: _vm._s(
                      _vm.icons(n) +
                        "&nbsp;&nbsp;&nbsp;" +
                        _vm.$t(_vm.typeLabel(n))
                    ),
                  },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showErrors["type"] && _vm.errors.has("type"),
                  expression: "showErrors['type'] && errors.has('type')",
                },
              ],
              staticClass: "form-input-error",
              on: {
                click: function ($event) {
                  return _vm.hideError("type")
                },
              },
            },
            [_vm._v(_vm._s(_vm.errors.first("type")))]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.ap.type != 4,
                expression: "ap.type != 4",
              },
            ],
            staticClass: "form-row row",
          },
          [
            _c("label", { staticClass: "col-4" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("ap.library.form.serial")) +
                  "   "
              ),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.ap.type == 2 || _vm.ap.type == 5,
                    expression: "ap.type == 2 || ap.type == 5",
                  },
                ],
                staticClass: "fa fa-question-circle",
                on: {
                  mouseover: _vm.showTooltipBeacon,
                  mouseout: _vm.hideTooltipBeacon,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tooltip left",
                  class: { show: _vm.showTooltip.beacon },
                  staticStyle: { width: "250px", top: "7px", left: "110px" },
                },
                [_vm._v(_vm._s(_vm.beaconTooltipContent))]
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ap.serial,
                  expression: "ap.serial",
                },
                { name: "validate", rawName: "v-validate" },
                {
                  name: "inputmask",
                  rawName: "v-inputmask",
                  value: _vm.typeMask(_vm.ap.type),
                  expression: "typeMask(ap.type)",
                },
              ],
              staticClass: "form-input col",
              attrs: {
                type: "text",
                name: "serial",
                "data-vv-rules": "required",
                "data-vv-as": _vm.$t("ap.library.form.serial"),
                "data-vv-validate-on": "none",
              },
              domProps: { value: _vm.ap.serial },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.ap, "serial", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showErrors["serial"] && _vm.errors.has("serial"),
                    expression: "showErrors['serial'] && errors.has('serial')",
                  },
                ],
                staticClass: "form-input-error",
                on: {
                  click: function ($event) {
                    return _vm.hideError("serial")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.errors.first("serial")))]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-row row" }, [
          _c("div", { staticClass: "col-4" }, [
            _c("label", [
              _c("div", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("ap.library.form.comment"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "relative" }, [
                  _c("i", {
                    staticClass:
                      "fa fa-question-circle text-warning warning-beepiz-remote-monitoring show",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tooltip left",
                      staticStyle: {
                        width: "250px",
                        top: "-2px",
                        left: "37px",
                      },
                    },
                    [
                      _vm._v(
                        "\n                               " +
                          _vm._s(
                            _vm.$t("ap.library.tooltip.content", {
                              univers: _vm.Utils().getApplicationName(),
                            })
                          ) +
                          "\n                            "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.ap.comment,
                expression: "ap.comment",
              },
              { name: "validate", rawName: "v-validate" },
            ],
            staticClass: "form-input col",
            attrs: {
              "data-vv-rules": "max:512",
              "data-vv-as": _vm.$t("ap.library.form.comment"),
              "data-vv-validate-on": "none",
            },
            domProps: { value: _vm.ap.comment },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.ap, "comment", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showErrors["comment"] && _vm.errors.has("comment"),
                  expression: "showErrors['comment'] && errors.has('comment')",
                },
              ],
              staticClass: "form-input-error",
              on: {
                click: function ($event) {
                  return _vm.hideError("comment")
                },
              },
            },
            [_vm._v(_vm._s(_vm.errors.first("comment")))]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }